module.exports = __webpack_public_path__ + "images/cancer.58fb258c2649282084b45ea90895e288.svg";